import React from "react"
export function TaHalf(props) {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <g
        id="prefix__Page-1"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g id="prefix__ta-half">
          <path
            d="M1.642 8.017c0-3.47 2.891-6.362 6.361-6.362 3.47 0 6.362 2.892 6.362 6.362s-2.892 6.361-6.362 6.361-6.361-2.795-6.361-6.361"
            id="prefix__Fill-22-path"
            fill="#FFF"
          />
          <g id="prefix__Group-3" fill="#00A680" fillRule="nonzero">
            <path
              d="M1.642 8.017c0 3.566 2.891 6.361 6.361 6.361 3.47 0 6.362-2.891 6.362-6.361 0-3.47-2.892-6.362-6.362-6.362S1.642 4.547 1.642 8.017zM0 8C0 3.663 3.566.096 8 0c4.434 0 8 3.566 8 8s-3.566 8-8 8a7.98 7.98 0 01-8-8zm8 3.991c-2.245 0-4-1.756-4-4 0-2.244 1.853-4 4-4v8z"
              id="prefix__Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}
